import { render, staticRenderFns } from "./learnToswimPages.vue?vue&type=template&id=0b7d142f&scoped=true"
import script from "./learnToswimPages.vue?vue&type=script&lang=js"
export * from "./learnToswimPages.vue?vue&type=script&lang=js"
import style0 from "./learnToswimPages.vue?vue&type=style&index=0&id=0b7d142f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7d142f",
  null
  
)

export default component.exports